import React, { useState } from 'react';

const accessOptions = ['UPI', 'Check', 'Online Transaction', 'Cash'];

const Payment = () => {
  const [projectData, setProjectData] = useState({
    access: [],
  });

  // Handle change for the access options
  const handleAccessChange = (event) => {
    const { value, checked } = event.target;
    setProjectData((prevData) => {
      if (checked) {
        return { ...prevData, access: [...prevData.access, value] };
      } else {
        return {
          ...prevData,
          access: prevData.access.filter((accessOption) => accessOption !== value),
        };
      }
    });
  };

  return (
    <div className="p-4 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6">Payment Methods</h1>
      <div className="grid grid-cols-2 gap-2">
        {accessOptions.map((accessOption, index) => (
          <label key={index} className="relative flex items-center cursor-pointer">
            <input
              type="checkbox"
              name="access"
              value={accessOption}
              checked={projectData.access.includes(accessOption)}
              onChange={handleAccessChange}
              className="form-checkbox h-4 w-4 text-black mr-2"
            />
            <span
              className={`px-4 py-2 poppins-regular rounded-full border flex items-center ${
                projectData.access.includes(accessOption)
                  ? 'bg-black text-white'
                  : 'bg-white text-gray-700 border-gray-300'
              }`}
            >
              {accessOption}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default Payment;
